import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';

export default function OpenEndedConstantSum({
  rows,
  openEndedStyle,
  openEndedInputSize,
  openEndedSignPlacement,
  openEndedSign,
  openEndedConstantSumType,
  min,
  max,
  decimals,
  total,
  getText,
}) {
  const lastIndex = rows.length - 1;

  return (
    <div className="answers">
      {rows.map((row, index) => (
        <Row
          row={row}
          rowOrder={index}
          openEndedStyle={openEndedStyle}
          openEndedInputSize={openEndedInputSize}
          openEndedSignPlacement={openEndedSignPlacement}
          openEndedSign={openEndedSign}
          min={min}
          max={max}
          decimals={decimals}
          total={total}
          showDivider={lastIndex > index}
          getText={getText}
          openEndedConstantSumType={openEndedConstantSumType}
        />
      ))}
      <div className="answer--matrix-open-ended-info-message-missing" />
    </div>
  );
}

OpenEndedConstantSum.propTypes = {
  rows: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  openEndedSign: PropTypes.string,
  openEndedSignPlacement: PropTypes.string,
  openEndedConstantSumType: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
  total: PropTypes.number,
  getText: PropTypes.func,
};
